import React from 'react';
import { InstagramIcon, LinkedinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#229954] text-white py-12" data-id="element-203">
      <div className="max-w-7xl mx-auto px-6" data-id="element-204">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-205">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-206">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hTs1bTRxhsd1rzFZCFkV1A/white.png" alt="Language Magnate Academy" className="h-32 w-auto mb-4" data-id="element-207" />
            <p className="text-green-50 mb-6 max-w-md" data-id="element-208">
              Empowering individuals through language mastery. Your journey to
              fluency starts here.
            </p>
            <div className="flex gap-4" data-id="element-209">
              <a href="https://www.instagram.com/thelanguagemagnateacademy/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1e8449] rounded-full flex items-center justify-center hover:bg-[#1a6f3e] transition-colors duration-200" data-id="element-210">
                <InstagramIcon size={20} data-id="element-211" />
              </a>
              <a href="https://www.linkedin.com/groups/16158022/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1e8449] rounded-full flex items-center justify-center hover:bg-[#1a6f3e] transition-colors duration-200" data-id="element-212">
                <LinkedinIcon size={20} data-id="element-213" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-214">
            <h4 className="font-semibold mb-4" data-id="element-215">Quick Links</h4>
            <ul className="space-y-2" data-id="element-216">
              <li data-id="element-217">
                <a href="#about" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-218">
                  About Us
                </a>
              </li>
              <li data-id="element-219">
                <a href="#courses" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-220">
                  Courses
                </a>
              </li>
              <li data-id="element-221">
                <a href="#services" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-222">
                  Services
                </a>
              </li>
              <li data-id="element-223">
                <a href="#testimonials" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-224">
                  Testimonials
                </a>
              </li>
              <li data-id="element-225">
                <a href="#contact" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-226">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-227">
            <h4 className="font-semibold mb-4" data-id="element-228">Newsletter</h4>
            <p className="text-green-50 text-sm mb-4" data-id="element-229">
              Subscribe for language tips and updates
            </p>
            <div className="flex gap-2" data-id="element-230">
              <input type="email" placeholder="Your email" className="flex-1 px-4 py-2 rounded-lg bg-[#1e8449] border border-[#1a6f3e] focus:border-white focus:ring-2 focus:ring-white transition-colors duration-200 outline-none text-sm placeholder-green-200" data-id="element-231" />
              <button className="bg-white text-[#229954] p-2 rounded-lg hover:bg-green-50 transition-colors duration-200" data-id="element-232">
                <MailIcon size={20} data-id="element-233" />
              </button>
            </div>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="border-t border-[#1e8449] pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-234">
          <p className="text-green-50 text-sm" data-id="element-235">
            © {currentYear} Language Magnate Academy. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm" data-id="element-236">
            <a href="#" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-237">
              Privacy Policy
            </a>
            <a href="#" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-238">
              Terms of Service
            </a>
            <a href="#" className="text-green-50 hover:text-white transition-colors duration-200" data-id="element-239">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}